import { Datepicker } from "flowbite-react";
import { useEffect, useState } from "react";
import { FaTimes } from "react-icons/fa";

const DatePicker = ({
	onChange,
	value,
	placeholder,
	onClear,
	isDisabled = false,
	minDate = null,
	maxDate = null,
	positionDatePicker = "",
}) => {
	const handleDateChange = (date) => {
		onChange(date);
	};
	const handleClear = () => {
		onClear(null);
	};

	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const handleClose = () => {
			setIsOpen(false);
		};

		window.addEventListener("scroll", handleClose, true);

		window.addEventListener("wheel", handleClose, { passive: true });

		return () => {
			window.removeEventListener("scroll", handleClose, true);
			window.removeEventListener("wheel", handleClose);
		};
	}, []);

	const customTheme = {
		popup: {
			root: {
				base: positionDatePicker,

				inner: "p-4 bg-dark-blue ",
				inline: " bg-dark-blue",
			},
			header: {
				title: "!bg-transparent m-1",
				selectors: {
					button: {
						view: "!bg-dark-blue text-white hover:bg-gray-600",
						prev: "!bg-gray-500 text-white  !hover:bg-gray-700 ",
						next: "!bg-gray-500 text-white  !hover:bg-gray-700 ",
					},
				},
			},
			view: {
				base: "bg-dark-blue ",
			},
			footer: {
				button: {
					today: "!bg-blue-gray text-white ",
					clear: "!bg-gray-500 text-white  !hover:bg-gray-700 ",
				},
			},
		},
		views: {
			days: {
				items: {
					item: {
						selected: "bg-blue-gray text-white hover:bg-gray-400",
						disabled: "text-red-500 opacity-50 cursor-not-allowed",
					},
				},
			},
		},
		maxDate: "text-red",
	};

	return (
		<div
			className="dark z-30 flex cursor-pointer items-center justify-between rounded-lg border border-gray-600 bg-input-bg pr-2.5 text-xs"
			onClick={() => setIsOpen(true)}
		>
			{" "}
			<Datepicker
				open={isOpen} // ✅ controlled
				theme={customTheme}
				placeholder={placeholder}
				autoHide={true}
				//dateFormat="yyyy-MM-dd"
				onSelectedDateChanged={handleDateChange}
				value={value}
				//	placeholderText="MM/DD/YYYY"
				style={{
					border: "none",
					boxShadow: "none",
					backgroundColor: "#272B49",
				}}
				className="w-full text-left text-gray-400 text-xs focus:border-none focus:ring-0"
				color={"#727DA366"}
				disabled={isDisabled}
				minDate={minDate}
				maxDate={maxDate}
			/>
			{value && (
				<FaTimes
					className="ml-1 cursor-pointer text-gray-400"
					onClick={(e) => {
						e.stopPropagation();
						handleClear();
					}}
				/>
			)}
		</div>
	);
};

export default DatePicker;
